import { render, staticRenderFns } from "./BlindBasicProfile.vue?vue&type=template&id=2681ee62&scoped=true"
import script from "./BlindBasicProfile.vue?vue&type=script&lang=js"
export * from "./BlindBasicProfile.vue?vue&type=script&lang=js"
import style0 from "./BlindBasicProfile.vue?vue&type=style&index=0&id=2681ee62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2681ee62",
  null
  
)

export default component.exports